{
  "name": "@xiboplayer/utils",
  "version": "0.7.23",
  "description": "Shared utilities for xiboplayer packages",
  "type": "module",
  "main": "./src/index.js",
  "types": "./src/index.d.ts",
  "exports": {
    ".": "./src/index.js",
    "./logger": "./src/logger.js",
    "./event-emitter": "./src/event-emitter.js",
    "./config": "./src/config.js"
  },
  "scripts": {
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage"
  },
  "dependencies": {
    "@xiboplayer/crypto": "workspace:*"
  },
  "devDependencies": {
    "vitest": "^4.1.2"
  },
  "keywords": [
    "xibo",
    "digital-signage",
    "utilities",
    "logger",
    "event-emitter"
  ],
  "author": "Pau Aliagas <linuxnow@gmail.com>",
  "license": "AGPL-3.0-or-later",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/xibo-players/xiboplayer.git",
    "directory": "packages/utils"
  },
  "homepage": "https://xiboplayer.org"
}
